import React from 'react';
import NumberMask from './NumberMask';
import TextInput from 'src/ui/library/TextInput';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import WithHeader from '../../wrappers/WithHeader';

const renderCurrencyControl = props => (
  <TextInput
    {...props}
    disableUnderline={true}
    InputProps={{
      disableUnderline: true,
      inputComponent: NumberMask,
      startAdornment: null, //props.value ? <InputAdornment position="start">$</InputAdornment> : null,
    }}
  />
);

const CurrencyControl = props => {
  let { helpText, ...otherProps } = props;

  return helpText ? (
    <InfoTooltip
      toolTipText={helpText}
      labelText={renderCurrencyControl(otherProps)}
      className="currency-tooltip"
      labelClassName="currency-tooltip-label"
    />
  ) : (
    renderCurrencyControl(otherProps)
  );
};

export default WithHeader(CurrencyControl);
